import React from "react";
import { useI18n } from "../../i18n/I18nProvider";

const AppVector = () => {
  const { t } = useI18n();
  const reminders = t("rows.calendar.reminders");

  return (
    <div className="mx-auto w-full max-w-[280px] rounded-[2rem] border-[6px] border-ink bg-paper px-3 pb-4 pt-3 text-ink shadow-card">
      <span className="mx-auto mb-3 block h-1.5 w-14 rounded-pill bg-hairline" aria-hidden="true" />
      <p className="text-caption text-mid-gray">{t("rows.rate.titleLabel")}</p>
      <p className="mt-1 text-caption font-semibold leading-snug text-ink">{t("rows.rate.titleValue")}</p>
      <p className="mt-3 text-caption text-mid-gray">{t("rows.rate.income")}</p>
      <p className="mt-0.5 text-body font-semibold text-ink">
        {t("rows.rate.amountValue")} {t("rows.desk.creditValue")}
      </p>
      <p className="mt-3 text-caption text-mid-gray">{t("rows.calendar.reminderLabel")}</p>
      <ul className="mt-1.5 flex flex-wrap gap-1.5 p-0">
        {reminders.map((item) => (
          <li key={item} className="list-none rounded-pill bg-rose px-2 py-0.5 text-caption text-[#241c3e]">
            {item}
          </li>
        ))}
      </ul>
      <div className="mt-3 rounded-nested rounded-bl-small bg-lilac px-2.5 py-2">
        <p className="text-caption font-medium text-[#241c3e]">{t("rows.rate.from")}</p>
        <p className="mt-0.5 text-caption text-[#241c3e]">{t("rows.rate.titleValue")}</p>
      </div>
    </div>
  );
};

export default AppVector;
